import type { FC, ReactElement } from "react";
import React from "react";
import {
  Body,
  Box,
  Flex,
  List,
  ListItem,
} from "@edreamsodigeo/prisma-design-system";

import type { PerksMarker } from "~/components/common/PerksList/contract";
import { BenefitsRevampLayoutTypes } from "~/components/acquisition/SubscriptionManagerDesktop/contract";

export interface FareSelectorSectionContentListProps {
  items: Array<FareSelectorSectionContentListItem>;
}

export enum pillType {
  NEUTRAL = "neutral",
  POSITIVE = "positive",
  INFORMATIVE = "informative",
  WARNING = "warning",
  NEGATIVE = "negative",
  BRAND = "brand",
  PROMOTIONAL = "promotional",
}

export enum markerType {
  DEFAULT = "default",
  INCLUDED = "included",
  EXCLUDED = "excluded",
  OPTIONAL = "optional",
  INFORMATION = "information",
}

export interface FareSelectorSectionListItem {
  marker: markerType;
  pill: {
    style: pillType;
    text: string | ReactElement;
  };

  text: string;
}

export interface FareSelectorSectionHighlightedListItemProps {
  background: string;
  items: FareSelectorSectionListItem[];
}

interface FareSelectorSectionHighlightedListProps {
  highlightedList?: FareSelectorSectionHighlightedListItemProps;
}

interface FareSelectorSectionProps
  extends FareSelectorSectionContentListProps,
    FareSelectorSectionHighlightedListProps {
  primeBenefitsTracking?: string;
  benefitsRevampLayout?: BenefitsRevampLayoutTypes;
}

interface FareSelectorSectionContentListItem {
  marker: PerksMarker;
  text: string | ReactElement;
  isBold?: boolean;
}

export const FareSelectorSectionContentList: FC<FareSelectorSectionProps> = ({
  items,
  primeBenefitsTracking,
  benefitsRevampLayout = undefined,
}) => (
  <Box>
    <Box
      pl={
        benefitsRevampLayout === BenefitsRevampLayoutTypes.CONDENSED
          ? "1x_small"
          : "base"
      }
      {...(primeBenefitsTracking && {
        "data-element-id": primeBenefitsTracking,
      })}
    >
      <List size={"small"} mt={"big"}>
        {items.map((item, idx) => (
          <ListItem marker={item.marker} key={`perksList-${idx}`}>
            <Flex pl={"1x_small"} data-element-id={`perksList-${idx + 1}`}>
              <Body
                weight={item.isBold ? "bold" : "normal"}
                type={"small"}
                color={"neutral.90"}
              >
                {item.text}
              </Body>
            </Flex>
          </ListItem>
        ))}
      </List>
    </Box>
  </Box>
);
